import { html, LitElement } from 'lit';
import lottie from 'lottie-web';

import { buildURL } from 'Utils/api-fetch-request';

import Styles from './vm-chatbot-loader.scss';

export default class VmChatbotLoader extends LitElement {
    static properties = {
        dataNamespace: { type: String, attribute: 'data-namespace' },
    };

    static styles = Styles;

    firstUpdated() {
        this.loadAnimation();
    }

    loadAnimation() {
        const animationPath = document.querySelector('meta[name="lottie-ai-landing"]')?.content;

        if (!animationPath) {
            return;
        }

        const animation = lottie.loadAnimation({
            name: `vm-chatbot-loader-${this.dataNamespace}`,
            container: this.renderRoot.querySelector('div'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: buildURL(animationPath, { name: `vm-chatbot-loader-${this.dataNamespace}` }),
        });

        animation.addEventListener('DOMLoaded', () => {
            animation.setSpeed(0.66);
            animation.playSegments([45, 135], true);
        });
    }

    render() {
        return html`<div></div>`;
    }
}
